/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "App Store에서 다운받기",
      "근처에 사는 사람들을 실제로 만나보세요",
      "Hives에서 새로운 사람들과 연결되세요.",
      "내 스타일의 사람들을 만나보세요",
      "모든 관심사를 Hive에서 찾을 수 있어요!",
      "스스로를 표현할 수 있는 안전한 공간",
      "비밀 혹은 공개 Hive 중에서 선택하세요.",
      "시작하기",
      "모든 관심사를 Hive에서 찾을 수 있어요",
      "Bumble BFF의 Hives에서 새로운 그룹의 사람들과 친해지세요",
      "Hives에 초대합니다",
      "Bumble BFF의 새로운 기능인 Hives에서 근처에 사는 새로운 그룹의 사람들을 만나보세요. Bumble 앱에서 오늘 BFF 프로필을 만들어보세요.",
      "Google Play에서 다운받기",
      "쿠키 관리",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "일"
            ],
            "singular": [
                  "일"
            ]
      },
      "hour": {
            "plural": [
                  "시간"
            ],
            "singular": [
                  "시간"
            ]
      },
      "minute": {
            "plural": [
                  "분"
            ],
            "singular": [
                  "분"
            ]
      },
      "month": {
            "plural": [
                  "개월"
            ],
            "singular": [
                  "개월"
            ]
      },
      "second": {
            "plural": [
                  "초"
            ],
            "singular": [
                  "초"
            ]
      },
      "year": {
            "plural": [
                  "년"
            ],
            "singular": [
                  "년"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
